'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TypDokumentApi = require('./../api/gen/dokumenty/TypDokumentApi');

var _TypDokumentApi2 = _interopRequireDefault(_TypDokumentApi);

var _StoreSuggestField = require('./StoreSuggestField');

var _StoreSuggestField2 = _interopRequireDefault(_StoreSuggestField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Field pro hledání typu dokumentů.
 */
var TypDokumentField = function (_React$Component) {
    (0, _inherits3.default)(TypDokumentField, _React$Component);

    function TypDokumentField() {
        (0, _classCallCheck3.default)(this, TypDokumentField);
        return (0, _possibleConstructorReturn3.default)(this, (TypDokumentField.__proto__ || (0, _getPrototypeOf2.default)(TypDokumentField)).apply(this, arguments));
    }

    (0, _createClass3.default)(TypDokumentField, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_StoreSuggestField2.default, (0, _extends3.default)({
                apiCall: function apiCall() {
                    return _TypDokumentApi2.default.findTypyDokumentu();
                },
                inputProps: { placeholder: "Typ dokumentu" },
                area: 'shared.typDokumentField',
                getItemId: function getItemId(item) {
                    return item ? item.kod : null;
                },
                getItemName: function getItemName(item) {
                    return item ? item.nazev : "";
                }
            }, this.props));
        }
    }]);
    return TypDokumentField;
}(_react2.default.Component);

exports.default = TypDokumentField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvVHlwRG9rdW1lbnRGaWVsZC5qc3giXSwibmFtZXMiOlsiVHlwRG9rdW1lbnRGaWVsZCIsIlR5cERva3VtZW50QXBpIiwiZmluZFR5cHlEb2t1bWVudHUiLCJwbGFjZWhvbGRlciIsIml0ZW0iLCJrb2QiLCJuYXpldiIsInByb3BzIiwiUmVhY3QiLCJDb21wb25lbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUE7OztJQUdNQSxnQjs7Ozs7Ozs7OztpQ0FFTztBQUNMLG1CQUFPLDhCQUFDLDJCQUFEO0FBQ0gseUJBQVM7QUFBQSwyQkFBTUMseUJBQWVDLGlCQUFmLEVBQU47QUFBQSxpQkFETjtBQUVILDRCQUFZLEVBQUNDLGFBQWEsZUFBZCxFQUZUO0FBR0gsc0JBQUsseUJBSEY7QUFJSCwyQkFBVztBQUFBLDJCQUFRQyxPQUFPQSxLQUFLQyxHQUFaLEdBQWtCLElBQTFCO0FBQUEsaUJBSlI7QUFLSCw2QkFBYTtBQUFBLDJCQUFRRCxPQUFPQSxLQUFLRSxLQUFaLEdBQW9CLEVBQTVCO0FBQUE7QUFMVixlQU1DLEtBQUtDLEtBTk4sRUFBUDtBQVFIOzs7RUFYMEJDLGdCQUFNQyxTOztrQkFjdEJULGdCIiwiZmlsZSI6IlR5cERva3VtZW50RmllbGQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBUeXBEb2t1bWVudEFwaSBmcm9tICcuLy4uL2FwaS9nZW4vZG9rdW1lbnR5L1R5cERva3VtZW50QXBpJztcbmltcG9ydCBTdG9yZVN1Z2dlc3RGaWVsZCBmcm9tIFwiLi9TdG9yZVN1Z2dlc3RGaWVsZFwiO1xuXG4vKipcbiAqIEZpZWxkIHBybyBobGVkw6Fuw60gdHlwdSBkb2t1bWVudMWvLlxuICovXG5jbGFzcyBUeXBEb2t1bWVudEZpZWxkIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcblxuICAgIHJlbmRlcigpIHtcbiAgICAgICAgcmV0dXJuIDxTdG9yZVN1Z2dlc3RGaWVsZFxuICAgICAgICAgICAgYXBpQ2FsbD17KCkgPT4gVHlwRG9rdW1lbnRBcGkuZmluZFR5cHlEb2t1bWVudHUoKX1cbiAgICAgICAgICAgIGlucHV0UHJvcHM9e3twbGFjZWhvbGRlcjogXCJUeXAgZG9rdW1lbnR1XCJ9fVxuICAgICAgICAgICAgYXJlYT1cInNoYXJlZC50eXBEb2t1bWVudEZpZWxkXCJcbiAgICAgICAgICAgIGdldEl0ZW1JZD17aXRlbSA9PiBpdGVtID8gaXRlbS5rb2QgOiBudWxsfVxuICAgICAgICAgICAgZ2V0SXRlbU5hbWU9e2l0ZW0gPT4gaXRlbSA/IGl0ZW0ubmF6ZXYgOiBcIlwifVxuICAgICAgICAgICAgey4uLnRoaXMucHJvcHN9XG4gICAgICAgIC8+O1xuICAgIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgVHlwRG9rdW1lbnRGaWVsZDtcbiJdfQ==